export const DOCUMENT_SCROLL_ROOT_ID = 'document-scroll-root';
